import * as yup from 'yup';
import { TagSchema } from 'features/tags/schemas/tag.schema';

export const PraiseFormSchema = yup
  .object()
  .shape(
    {
      receiver: yup
        .array()
        .label('receiver')
        .min(1, 'Praised person is required')
        .required('Praised person is required'),
      headline: yup
        .string()
        .nullable()
        .when('description', {
          is: (description: string) => !description,
          then: (schema) => schema.required('Headline is required when description is empty'),
          otherwise: (schema) => schema.notRequired(),
        }),
      description: yup
        .string()
        .nullable()
        .when('headline', {
          is: (headline: string) => !headline,
          then: (schema) => schema.required('Description is required when headline is empty'),
          otherwise: (schema) => schema.notRequired(),
        }),
      tags: yup.array().of(TagSchema).label('tags'),
    },
    [
      /*
       * Don't validate description when headline changes, and vice versa; each
       * field already checks the other, to make the field required or not, so if we don't
       * disable these below, yup will spot a dependency loop and error out.
       */
      ['headline', 'description'],
      ['description', 'headline'],
    ],
  )
  .required();
